export const useCases = [
	{
		id: 0,
		title: "page_editor_block1_tool1",
		adaptiveTitle: null,
		imageUrl: "/image_editor/landing/block2/image1.jpg",
		adaptiveUrl: null,
	},
	{
		id: 1,
		title: "page_editor_block1_tool2",
		adaptiveTitle: "page_editor_block1_mob_tool2",
		imageUrl: "/image_editor/landing/block2/image2.jpg",
		adaptiveUrl: "/image_editor/landing/block2/adaptive2.jpg",
	},
	{
		id: 2,
		title: "page_editor_block1_tool3",
		adaptiveTitle: null,
		imageUrl: "/image_editor/landing/block2/image3.jpg",
		adaptiveUrl: null,
	},
	{
		id: 3,
		title: "page_editor_block1_tool4",
		adaptiveTitle: "page_editor_block1_mob_tool1",
		imageUrl: "/image_editor/landing/block2/image4.jpg",
		adaptiveUrl: "/image_editor/landing/block2/adaptive4.jpg",
	},
	{
		id: 4,
		title: "page_editor_block1_tool5",
		adaptiveTitle: null,
		imageUrl: "/image_editor/landing/block2/image5.jpg",
		adaptiveUrl: null,
	},
	{
		id: 5,
		title: "page_editor_block1_tool6",
		adaptiveTitle: "page_editor_block1_mob_tool3",
		imageUrl: "/image_editor/landing/block2/image6.jpg",
		adaptiveUrl: "/image_editor/landing/block2/adaptive6.jpg",
	},
];

export const scrollData = [
	{ id: 1, dicTitle: "page_editor_block3_text2", title: "Functions based on powerful AI", imageUrl: "/image_editor/landing/scroll_block/scroll1.jpg" },
	{ id: 2, dicTitle: "page_editor_block3_text1", title: "Wide range of editing tools", imageUrl: "/image_editor/landing/scroll_block/scroll2.jpg" },
	{ id: 3, dicTitle: "page_editor_block3_text3", title: "No professional knowledge required", imageUrl: "/image_editor/landing/scroll_block/scroll3.jpg" },
];
